var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'back-button',
        {
            'back-button--black': _vm.isBlack,
            'back-button--no-absolute': !_vm.isAbsolute,
            'back-button--hidden-on-desktop': _vm.isHiddenOnDesktop,
            'back-button--partner-custom-embed': _vm.partnerAppEmbedCustomization,
            'back-button--arabic': _vm.isArabic
        }
    ],on:{"click":function($event){return _vm.goBack()}}})}
var staticRenderFns = []

export { render, staticRenderFns }